/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
/**
 * Event interface implementation.
 *
 * It's not possible to inherit from global Event because it's a DOM class.
 * Therefore we need to have our own implementation compatible with
 * TypeScript's declared interface.
 */
export default class CustomEventImpl<T = any> implements CustomEvent<T> {
    bubbles: boolean = true;
    cancelable: boolean = true;
    composed: boolean;
    detail: T;
    currentTarget: EventTarget;
    eventPhase: number;
    isTrusted: boolean = false;
    returnValue: boolean = true;
    /* unused: IE alias for Event.target */
    srcElement: Element | null;
    target: EventTarget;
    timeStamp: number = performance.now();
    type: string;
    scoped: boolean;
    NONE: number;

    AT_TARGET: number;
    BUBBLING_PHASE: number;
    CAPTURING_PHASE: number;

    private stopPropagationFlag: boolean = false;

    constructor(typeArg: string, eventInitDict?: CustomEventInit<T>) {
        eventInitDict = eventInitDict || {};
        this.initEvent(typeArg, eventInitDict.bubbles, eventInitDict.cancelable);
        this.detail = eventInitDict.detail!;
    }

    get cancelBubble() {
        return this.stopPropagationFlag;
    }

    set cancelBubble(value: boolean) {
        if (value) {
            this.stopPropagationFlag = value;
        }
    }

    get defaultPrevented() {
        return !this.returnValue;
    }

    initEvent(type: string, bubbles?: boolean, cancelable?: boolean): void {
        this.type = type;
        this.bubbles = typeof bubbles === 'undefined' ? true : bubbles;
        this.cancelable = typeof cancelable === 'undefined' ? true : cancelable;
    }

    initCustomEvent(typeArg: string, canBubbleArg: boolean, cancelableArg: boolean, detailArg: T): void {
        this.initEvent(typeArg, canBubbleArg, cancelableArg);
        this.detail = detailArg;
    }

    preventDefault(): void {
        if (this.cancelable) {
            this.returnValue = false;
        }
    }

    stopImmediatePropagation(): void {
        // not implemented: this.stopImmediatePropagationFlag = true;
        this.stopPropagationFlag = true;
    }

    stopPropagation(): void {
        this.stopPropagationFlag = true;
    }

    composedPath(): EventTarget[] {
        return [this.target];
    }
}
